import auth from '../apis/auth';
import { stopSubmit } from 'redux-form';
import {
    SIGN_IN,
    SIGN_OUT,
    SIGN_UP,
    REFRESH_SUCCESS,
    REFRESH_FAIL,
    EDIT_ME,
    SHOW_ERROR,
    VERIFY_EMAIL,
} from './types';
import history from '../history';
import errorObject from '../components/helpers/errorObject';

export const signIn = (formValues) => async dispatch => {
    await auth.post('/api/auth/login', formValues)
        .then(response => {
            dispatch({ type: SIGN_IN, payload: response.data.user })
            history.push('/');
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch(stopSubmit('loginForm', errorObj));
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
};

export const signOut = () => async dispatch => {
    await auth.get('/api/auth/logout')
        .then(() => {
            dispatch({ type: SIGN_OUT })
            history.push('/login/');
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/login/');
        })
};

export const refreshToken = () => async dispatch => {
    return auth.get('/api/auth/refresh', { withCredentials: true })
        .then(({ data }) => {
            dispatch({ type: REFRESH_SUCCESS, payload: data.user });
            return data;
        })
        .catch((err) => {
            dispatch({ type: REFRESH_FAIL });
            history.push('/login/');
        });
};

// export const refreshToken = () => async dispatch => {
//     await auth.get('/api/auth/refresh')
//         .then(response => {
//             dispatch({ type: REFRESH_SUCCESS, payload: response.data.user })
//         })
//         .catch(() => {
//             dispatch({ type: REFRESH_FAIL })
//             history.push('/login/');
//         })
// };

export const changePassword = (formValues) => async dispatch => {
    await auth.post('/api/auth/change_password', formValues)
        .then(response => {
            dispatch({ type: EDIT_ME, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch(stopSubmit('passwordForm', errorObj));
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
};

export const signUp = (formValues) => async dispatch => {
    await auth.post('/api/auth/signup', formValues)
        .then(response => {
            dispatch({ type: SIGN_UP, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch(stopSubmit('accountForm', errorObj));
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
};

export const verifyEmail = (verification) => async dispatch => {
    await auth.post('/api/auth/verify', verification)
        .then(response => {
            dispatch({ type: VERIFY_EMAIL, payload: response.data.user });
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/login/');
        })
}

export const resendVerificationEmail = (email) => async dispatch => {
    await auth.post('/api/mail/resend-verification', email)
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/login/');
        })
}

export const sendPasswordResetEmail = (formValues) => async dispatch => {
    await auth.post('/api/auth/reset-password-email', formValues)
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/login/');
        })
}

export const resetPassword = (values) => async dispatch => {
    await auth.post('/api/auth/reset-password', values)
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const signInGoogle = () => async dispatch => {
    await auth.get('/api/auth/login_with_google')
        .then(response => {
            history.push(response.data.url)
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            history.push('/login/');
        })
};

export const signUpGoogle = (values) => async dispatch => {
    await auth.post('/api/auth/signup_with_google', values)
        .then(response => {
            dispatch({ type: SIGN_UP, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch(stopSubmit('accountForm', errorObj));
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
};